export const highlightZipcodeOnPaymentError = () => {
    if ($("#ccZipError").length > 0) $("#add-update-address-zip").parent().addClass("has-error");

    $("#add-update-address-zip").on( "click", function() {
        if($("#add-update-address-zip").parent().hasClass("has-error")) {
            $("#add-update-address-zip").parent().removeClass('has-error');
        }
    });
};



